<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- boton crear -->
    <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex flex-row-reverse pt-0">
        <TableButtonComp normalButton iconBut="fas fa-plus" @click="addItem" text-button="Crear área" />
      </v-col>
    </v-row>
    <v-row class="">
      <v-col cols="12" v-if="mostrarMensaje">
        <v-card outlined>
          <v-card-text style="min-height:200px" class="text-center d-flex align-center justify-center">
            Aún no has agregado ningún área a configuración del sistema
          </v-card-text>
        </v-card>
        <!-- <v-alert color="#ffbc00" icon="fas fa-exclamation-triangle" dark border="left" prominent elevation="5" dense>
          <span class="font-weight-black">
            Aún no has agregado ningún Área a {{ $t("modulos.5") }}
          </span>
        </v-alert> -->
      </v-col>

      <v-col cols="12" v-for="item in AreasAdmin" :key="item.id">
        <v-alert dense :style="{ background: item.color_nivel, color: '#fff' }"><b>NIVEL:</b> {{ item.desc_nivel }}
        </v-alert>
        <v-row>
          <v-col cols="12" sm="6" md="4" xs="12" class="d-flex justify-center" v-for="(area, i) in item.areas" :key="i">
            <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + area.color }">

              <v-list-item>
                <v-list-item-avatar class="ml-0 mr-1" size="50" :color="area.color_area">
                  <v-icon dark>{{ area.icono_area }}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="">
                  <div class="overline mb-4">{{ area.area_nivel_id }}</div>
                  <span class="mb-1 black--text">
                    <h5>{{ area.desc_area }}</h5>
                  </span>
                </v-list-item-content>
              </v-list-item>

              <v-card-text :style="{ background: area.color }" id="text">{{
                area.desc_nivel
              }}</v-card-text>

              <v-card-actions>
                <v-row>
                  <v-spacer></v-spacer>

                  <v-col cols="12" md="6" class="d-flex justify-end gap-10px" style="
                      padding-bottom: 1px !important;
                      padding-top: 10px !important;
                      margin-bottom: 15px !important;
                    ">
                    <TableButtonComp @click="editItem(area)" v-if="componenteEvento.editar_submodulo" editButton
                      tooltipText="Editar área" />

                    <TableButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(area)"
                      tooltipText="Eliminar área" deleteButton />
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!---------modal Crear Y Editar Area -------->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp max-width="800" v-model="modal_area" :title="formTitle" @close-modal="modal_area = false">
        <template v-slot:body>
          <v-row>
            <v-col cols="12" md="6">
              <!-- El campo Nivel y ÁreaMinedu no se pueden editar -->
              <AutocompleteComp :isDisable="isEdit" textLabel="Nivel" v-model="dataForm.id_nivel"
                :items="NivelMantenimiento" item-value="id" item-text="desc_nivel" @change="getAreasMineduNivel()"
                :rules="validationRules.validateNivel" />
            </v-col>

            <v-col cols="12" md="6" class="pb-0">
              <!-- El campo Nivel y ÁreaMinedu no se pueden editar -->
              <textfieldComp v-if="evento == 'editar'" text-label="Área según Minedu" outlined
                v-model="dataForm.area_click" dense disabled />

              <AutocompleteComp v-else :isDisable="isEdit" textLabel="Área según Minedu"
                v-model="dataForm.id_area_clickone" :items="areaMinedu" item-value="id" item-text="desc_area"
                :readonly="evento == 'editar'" :rules="validationRules.validateArea"
                @change="selectAreaMinedu(dataForm.id_area_clickone)" />

            </v-col>

            <v-col cols="12" md="6" class="pb-0" v-if="parametros.cod_siagie">
              <!-- <textfieldComp :textLabel="$t('titulo.codigoArea')" v-model="dataForm.codigo_siagie"
                :rules="validationRules.siagievalidate" /> -->

              <v-text-field
                v-model="dataForm.codigo_siagie"
                :label="$t('titulo.codigoArea')"
                :rules="[validationRuls.required, validationRuls.max10]"
              ></v-text-field>

            </v-col>

            <v-col cols="12" md="6" lg="6" class="pb-0">
              <textfieldComp textLabel="Nombre del área" v-model="dataForm.desc_area"
                :rules="validationRules.validatenameArea" />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-row>
                <v-col>
                  <label class="black--text">
                    <h3>Seleccionar color</h3>
                  </label>
                </v-col>
              </v-row>

              <v-color-picker v-model="dataForm.color_area" width="400px" :mode.sync="mode"></v-color-picker>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <v-row>
                <v-col>
                  <label class="black--text">
                    <h3>Seleccionar ícono</h3>
                  </label>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="2" md="2" lg="2" v-for="icon of iconos" :key="icon.id" class="d-flex justify-center">
                  <v-card class="text-center pt-1 pb-1" @click="agregarIcono(icon.nombre)">
                    <v-icon :style="{ color: dataForm.color_area }">{{
                      icon.nombre
                    }}</v-icon>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-center text-center">
              <v-card style="min-width: 60px" :color="dataForm.color_area" class="px-3 py-3">
                <v-icon large dark>{{ dataForm.icono_area }}</v-icon>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions>
          <v-spacer></v-spacer>
          <TableButtonComp normalButton v-if="evento == 'editar'" @click="editArea(dataForm.id)"
            text-button="Guardar cambios" iconBut="fas fa-save" />

          <TableButtonComp normalButton v-if="evento == 'agregar'" @click="addMantenimientoAreas()" text-button="Guardar"
            iconBut="fas fa-save" />
        </template>
      </ComunDialogComp>
    </v-form>

    <!--------fin del editor de area ----->

    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->
    <ComunDialogComp Deletedialog v-model="dialog_delete" titleWindow="Eliminar área" @close-modal="dialog_delete = false"
      @delete-item="deleteArea" @cancel-item="dialog_delete = false">
      <template v-slot:body>
        <h3>¿Está seguro de eliminar este registro? <br /></h3>
        <v-chip color="primary" dense label>
          {{ name_delete }}
        </v-chip>
      </template>
    </ComunDialogComp>

  </div>
</template>

<script>
import axios from "../../helpers/axios";
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import AutocompleteComp from "../../components/ComponentsEst/AutocompleteComp.vue";
import textfieldComp from "../../components/ComponentsEst/textfieldComp.vue";
import ComunDialogComp from "../../components/ComponentsEst/ComunDialogComp.vue";

import { validationRules } from "../../helpers/validatorHelpers.js";
import { validationRuls } from "../../../src/functions/validacion";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";

export default {
  components: {
    TableButtonComp,
    AutocompleteComp,
    textfieldComp,
    ComunDialogComp,
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 36, id_modulo: 5 }, //sud_modulo y modulo

    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////

    AreasAdmin: [],
    mostrarMensaje: false,

    // modal agregar editar area
    evento: "",
    dataForm: {},
    mode: "hexa",
    modal_area: false,

    NivelMantenimiento: [],
    parametros: [],
    areaMinedu: [],
    /////////////////////////////////

    // modal confirmacion
    dialog_delete: false,
    name_delete: "",
    id_delete: null,
    /////////////////////////////////
  }),

  mounted() {
    this.getAllAreasAdmin();
  },

  computed: {
    validationRuls(){
      return validationRuls;
    },
    validationRules() {
      return validationRules;
    },
    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar" ? "Crear área" : "Editar área";
    },

    isEdit() {
      return this.evento === "editar"
    },

    ...mapState({
      iconos: (state) => state.areas.iconos,
    }),

    rules() {
      const rules = [];

      if (this.parametros.cod_siagie == true) {
        const rule = (v) => !!v || "Campo requerido";

        rules.push(rule);
      }

      return rules;
    },
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //-- METODO CONDICIONADO QUE LISTA TODAS LAS AREAS DE MANTENIMIENTOS DE UN COLEGIO, SEGUN ID_COLEGIO. LOS REGISTROS SON ASOCIADOS A LA
    //-- DESCRIPCION DEL NIVEL AL CUAL PERTENECE.
    //---------- Traer areas de Mantenimiento -----------
    async getAllAreasAdmin() {
      this.mostrarMensaje = false;
      var id = this.datoLogin.id_colegio;

      try {
        let response = await axios.get("/mantenimiento/area/" + id + "");
        this.AreasAdmin = this.AreasAdminFilter = response.data;
        // console.log(JSON.stringify(this.AreasAdmin))

        if (this.AreasAdmin.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    async limpiarForm() {
      this.dataForm = {
        id_colegio: this.datoLogin.id_colegio,
        desc_area: "",
        id_area_clickone: null,
        desc_area_clickone: "",
        id_nivel: 0,
        id_us_ing: this.datoLogin.id,
        fec_us_ing: "",
        id_us_mod: this.datoLogin.id,
        fec_us_mod: "",
        estado: 1,
        icono_area: "",
        color_area: "#0277BD",
        id_pais: this.datoLogin.id_pais,
        ck1: false,
        codigo_siagie: "",
      };

      //this.NivelMan = null
      this.areaMinedu = [];
      this.NivelMantenimiento = [];

      this.$refs.formDatos.resetValidation();
    },

    //-------abrir modal agregar ----
    addItem() {
      this.limpiarForm();
      this.modal_area = true;
      this.evento = "agregar";

      this.getAllParametrosPais(sessionStorage.id_pais);
      this.getAllNivelesMantenimiento();
    },

    //////  traer parametros de configuracion segun pais ///////
    async getAllParametrosPais(id) {
      try {
        let response = await axios.get("/sistema/parametroPais/" + id + "");
        console.log("res:", response);
        this.parametros = response.data;
        //console.log(this.parametros)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },
    ////////////////////////////////////////////////

    //-- METODO CONDICIONADO QUE LISTA TODOS LOS NIVELES DE UN COLEGIO, SEGUN ID_COLEGIO
    //---------traer paises -----------------
    async getAllNivelesMantenimiento() {
      var id = this.datoLogin.id_colegio;

      try {
        let response = await axios.get("/mantenimiento/nivel/" + id + "");
        this.NivelMantenimiento = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //////////  traer areas del minedu segun nivel //////////
    async getAreasMineduNivel() {
      try {
        let resp = await axios.get(
          `/mantenimiento/area/list/areaMantXNivel/${this.dataForm.id_nivel}`
        );

        const filtroAreas = this.AreasAdminFilter.filter((el) => el.id_nivel == this.dataForm.id_nivel)

        if (filtroAreas.length == 0) {
          this.areaMinedu = resp.data;
        } else {
          const AreasFiltrado = filtroAreas[0].areas;
          this.areaMinedu = resp.data.filter(elementoA => !AreasFiltrado.some(elementoB => elementoA.id == elementoB.id_area_clickone));
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    ///////// añadir nivel a valor y a campo nombre
    selectAreaMinedu(item) {
      let filtroArea = this.areaMinedu.filter((el) => el.id == item);

      this.dataForm.desc_area = filtroArea[0].desc_area;
      this.dataForm.icono_area = filtroArea[0].icono_area;
      //this.dataForm.color_area = filtroArea[0].color_area

      if (filtroArea[0].color_area == null) {
        this.dataForm.color_area = "#0277BD";
      } else {
        this.dataForm.color_area = filtroArea[0].color_area;
      }
    },
    ////////////////////////////////////////////////

    //----------crear area------
    async addMantenimientoAreas() {
      if (this.$refs.formDatos.validate()) {
        if (!this.dataForm.icono_area) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "Seleccionar un ícono",
            tiempo: null,
          });
        } else {
          let validate_desc = await this.validateAreaNivel();

          if (validate_desc.row === "1") {
            this.setEnviarMens({
              tipo: "E",
              mensaje: "Ya existe un registro con esa descripción",
              tiempo: null,
            });
          } else {
            try {
              let response = await axios.post(
                "/mantenimiento/area/",
                this.dataForm
              );

              if (response.data.messageT == "S") {
                this.modal_area = false;
                this.getAllAreasAdmin(); //-- METODO CONDICIONADO QUE LISTA TODAS LAS AREAS DE UN COLEGIO, SEGUN ID_COLEGIO
                this.limpiarForm();
              }

              this.setEnviarMens({
                tipo: response.data.messageT,
                mensaje: `${response.data.message}`,
                tiempo: null,
              });
            } catch (e) {
              this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
            }
          }
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Por favor, complete y verifique todos los campos para guardar`,
          tiempo: null,
        });
      }
    },

    //////// metodo para consultar que no exista un area con el
    //////// mismo nombre asignada a ese nivel
    ////////////////////////////////////////////////////
    async validateAreaNivel() {
      let data = [];
      let params = {
        id_nivel: this.dataForm.id_nivel,
        desc_area: this.dataForm.desc_area,
      };

      try {
        let response = await axios.post(
          "/mantenimiento/area/validateAreaNombre/",
          params
        );
        data = response.data;
        //console.log(response.data)
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }

      return data;
    },

    // ------editar area -------
    async editItem(area) {
      // console.log('Esta es el area seleccionada', area)
      this.limpiarForm();
      this.getAllParametrosPais(sessionStorage.id_pais);
      this.evento = "editar";

      this.modal_area = true;
      // this.dataForm.desc_area_clickone = area.area_click
      this.dataForm = Object.assign({}, area);
      console.log('el armado', this.dataForm);
      this.getAllNivelesMantenimiento();

      this.getAreasMineduNivel();
    },

    //--------------editar area--------------
    async editArea(id) {
      if (this.$refs.formDatos.validate()) {
        if (!this.dataForm.icono_area) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "Seleccionar un Ícono",
            tiempo: null,
          });
        } else {
          this.dataForm.id_us_mod = this.datoLogin.id;

          try {
            let response = await axios.put(
              "/mantenimiento/area/" + id,
              this.dataForm
            );

            if (response.data.messageT == "S") {
              this.modal_area = false;
              this.getAllAreasAdmin(); //-- METODO CONDICIONADO QUE LISTA TODAS LAS AREAS DE UN COLEGIO, SEGUN ID_COLEGIO
              this.limpiarForm();
            }

            this.setEnviarMens({
              tipo: response.data.messageT,
              mensaje: `${response.data.message}`,
              tiempo: null,
            });
          } catch (e) {
            this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
          }
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Por favor, complete y verifique todos los campos para guardar`,
          tiempo: null,
        });
      }
    },

    /////  funcion para confirmar delete
    deleteConfirm(item) {
      //console.log(item)
      this.dialog_delete = true;
      this.id_delete = item.id;
      this.name_delete = `Área: ${item.desc_area}`;
      //  this.desc_delete = `${items.descripcion_perfil} - (${items.id})`
    },

    //-- 26-02-2020. ROBERT.
    //-- METODO QUE PERMITE ELIMINAR UN AREA DEL AMBITO DE MANTENIMIENTO
    //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    //------------borrar Area -------------
    async deleteArea() {
      try {
        let response = await axios.delete(
          "/mantenimiento/area/" + this.id_delete
        );

        if (JSON.stringify(response.data.messageT) == JSON.stringify("S")) {
          this.getAllAreasAdmin();
        }

        this.dialog_delete = false;
        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: `${response.data.message}`,
          tiempo: null,
        });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    //---------agregar icono ---------
    agregarIcono(icono) {
      this.dataForm.icono_area = icono;
    },
  },
};
</script>

<style scoped>
#text {
  color: #ffffff;
  padding: 1%;
  padding-left: 10%;
}
</style>
